import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ru from './locales/ru';
import uz from './locales/uz';
import en from './locales/en';
import moment from 'moment';

Vue.use(VueI18n);

export const locales = [
  { key: 'uz', default: true },
  { key: 'ru', default: false },
  { key: 'en', default: false },
]

const messages = { ru, uz, en },
      defaultLocale = localStorage.getItem('locale') || 'uz'

export const i18n = new VueI18n({
  locale: defaultLocale,
  messages
});

moment.locale(defaultLocale);

Vue.prototype.$locale = {
  change(locale) {
    moment.locale(locale);
    i18n.locale = locale;
    localStorage.setItem('locale', locale)
  },
  current() {
    return i18n.locale;
  },
};

export default i18n;
